import React from 'react';

import { BasicButton } from '@adsk/alloy-react-button';
import { ChevronDownIcon } from '@adsk/alloy-react-icon';
import theme, { StylableComponent } from '@adsk/alloy-react-theme';

import { GetToggleButtonProps } from '../../types';

type ToggleButtonProps = StylableComponent<HTMLButtonElement> &
  GetToggleButtonProps & {
    isOpen: boolean;
    disabled?: boolean;
  };

const ToggleButton = ({
  style,
  isOpen,
  getToggleButtonProps,
  ...props
}: ToggleButtonProps) => {
  const {
    style: _ignoredStyle,
    css: _ignoredCss,
    onClick: toggleOnClick,
    ...toggleButtonProps
  } = getToggleButtonProps();

  return (
    <BasicButton
      data-testid={'ControlLabel__toggle'}
      style={{ padding: 0, height: 32 }}
      {...toggleButtonProps}
      onClick={(e) => {
        e.stopPropagation();
        toggleOnClick?.(e);
      }}
      {...props}
    >
      <ChevronDownIcon
        style={[
          {
            color: theme.colors.charcoal700,
            ...(isOpen && {
              transform: 'rotate(180deg)',
            }),
          },
          style,
        ]}
      />
    </BasicButton>
  );
};

export default ToggleButton;
